import React from "react";
import avatar from "../../../assets/images/avatar-3.jpg";

const Comment = () => {
  return (
    <div>
      <h3 className="nk-decorated-h-2">
        <span>
          <span className="text-main-1">3</span> Comments
        </span>
      </h3>
      <div className="nk-gap"></div>
      <div className="nk-comments">
        <div className="nk-comment">
          <div className="nk-comment-meta">
            <img
              src={avatar}
              alt="Witch Murder"
              className="rounded-circle"
              width="35"
            />
            by <a href="https://nkdev.info">Witch Murder</a> in 20 September,
            2018
            <a
              href="#"
              className="nk-btn nk-btn-rounded nk-btn-color-dark-3 float-right"
            >
              Reply
            </a>
          </div>
          <div className="nk-comment-text">
            <p>
              This sounded nonsense to Alice, so she said nothing, but set off
              at once toward the Red Queen. To her surprise, she lost sight of
              her in a moment, and found herself walking in at the front-door
              again.
            </p>
          </div>
          <div className="nk-comment">
            <div className="nk-comment-meta">
              <img
                src={avatar}
                alt="Hitman"
                className="rounded-circle"
                width="35"
              />{" "}
              by <a href="https://nkdev.info">Hitman</a> in 20 September, 2018{" "}
              <a
                href="#"
                className="nk-btn nk-btn-rounded nk-btn-color-dark-3 float-right"
              >
                Reply
              </a>
            </div>
            <div className="nk-comment-text">
              <p>
                To her surprise, she lost sight of her in a moment, and found
                herself walking in at the front-door again.
              </p>
            </div>
          </div>
        </div>
        <div className="nk-comment">
          <div className="nk-comment-meta">
            <img
              src={avatar}
              alt="Wolfenstein"
              className="rounded-circle"
              width="35"
            />{" "}
            by <a href="https://nkdev.info">Wolfenstein</a> in 21 September,
            2018{" "}
            <a
              href="#"
              className="nk-btn nk-btn-rounded nk-btn-color-dark-3 float-right"
            >
              Reply
            </a>
          </div>
          <div className="nk-comment-text">
            <p>
              The sight of the tumblers restored Bob Sawyer to a degree of
              equanimity which he had not possessed since his interview with his
              landlady. His face brightened up, and he began to feel quite
              convivial.
            </p>
          </div>
        </div>
      </div>
      <div className="nk-gap-2"></div>
      <h3 className="nk-decorated-h-2">
        <span>
          <span className="text-main-1">Leave</span> a Reply
        </span>
      </h3>
      <div className="nk-gap"></div>
      <div className="nk-reply">
        <form action="#" className="nk-form" noValidate="noValidate">
          <div className="row sm-gap vertical-gap">
            <div className="col-md-4">
              <input
                type="email"
                className="form-control required"
                name="email"
                placeholder="Email *"
              />
            </div>
            <div className="col-md-4">
              <input
                type="text"
                className="form-control required"
                name="name"
                placeholder="Name *"
              />
            </div>
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Website"
              />
            </div>
          </div>
          <div className="nk-gap-1"></div>
          <textarea
            className="form-control required"
            name="message"
            rows="5"
            placeholder="Message *"
            aria-required="true"
          ></textarea>
          <div className="nk-gap-1"></div>
          <div className="nk-form-response-success"></div>
          <div className="nk-form-response-error"></div>
          <button className="nk-btn nk-btn-rounded nk-btn-color-main-1">
            Post Comment
          </button>
        </form>
      </div>
    </div>
  );
};

export default Comment;
